import React, { PureComponent } from "react";
import moment from "moment";

//import _ from "i18n";

export default class NotifsComponent extends PureComponent {
  renderNotifs() {
    const { fetched, notifs, lng } = this.props;

    if (!fetched || !notifs || notifs.length === 0) {
      return null;
    }

    return (
      <ul className="sub-menu__dropdown">
        {notifs.map(notif => {
          const subjecAttr = `subject${lng.charAt(0).toUpperCase() +
            lng.slice(1)}`;
          return (
            <li>
              <a>
                <span>{notif[subjecAttr]}</span>
                <div className="infos">{moment(notif.createdAt).fromNow()}</div>
              </a>
            </li>
          );
        })}
      </ul>
    );
  }
  render() {
    return (
      <li className="social-links expandable notif">
        <a className="triangle">
          <img alt="" src="/img/icons/notifs.svg" className="NOTIFS" />
        </a>
        <div className="social-links__wrapper">
          <div className="social-links__header">
            Notifications de mises à jour
          </div>
          <div className="social-links__body">{this.renderNotifs()}</div>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Notifs/NotifsComponent.js